import React, {Component} from "react";
import PropTypes from "prop-types";
import * as ListingProps from './listing-props'
import {ListingSummary} from "./ListingSummary";
import {locationToListingSummary} from "./util";
import {ListingTitle} from "./ListingTitle";
import {ProviderItem} from "../../../services/providers/ProviderItems";

export class MissingListingDetails extends Component {
  static propTypes = {
    location: ListingProps.location.isRequired,
    provider: PropTypes.string.isRequired
  };

  render() {
    const {location, provider} = this.props;
    return <div className="row">
      <div className="col-md-4">
        <ListingTitle title="Missing Listing" />
        <ProviderItem provider={provider}/>
      </div>
      <div className="col-md-4">
        <ListingTitle title="Expected Location"/>
        <ListingSummary listing={locationToListingSummary(location)} />
      </div>
    </div>
  }
}